<template>

  <!-- 浮动导航 -->
  <nav class="floating-nav">
    <v-list dense>
      <v-list-item to="/products/audit">
        <v-list-item-title> <v-icon class="mr-2">mdi-text-box-check-outline</v-icon>审计评估</v-list-item-title>
      </v-list-item>
      <v-list-item to="/products/tax">
        <v-list-item-title> <v-icon class="mr-2">mdi-cash-check</v-icon>税务筹划</v-list-item-title>
      </v-list-item>
      <v-list-item to="/products/accounting">
        <v-list-item-title> <v-icon class="mr-2">mdi-abacus</v-icon>会计理账</v-list-item-title>
      </v-list-item>
      <v-list-item to="/products/consulting">
        <v-list-item-title> <v-icon class="mr-2">mdi-account-question-outline</v-icon>管理咨询</v-list-item-title>
      </v-list-item>
      <v-list-item to="/products/hongkong">
        <v-list-item-title> <v-icon class="mr-2">mdi-office-building</v-icon>香港业务</v-list-item-title>
      </v-list-item>
    </v-list>
  </nav>
</template>

<script setup>
</script>

<style scoped>
.floating-nav {
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  top: 60px;
  /* 根据需要调整距离顶部的距离 */
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
